module.exports = "https://cwa.roocdn.com/_next/static/favicon-32x32.bbad45b1.png";